export const getFilename = (filePath: string) => {
  const startIndex = filePath.indexOf("\\") >= 0 ? filePath.lastIndexOf("\\") : filePath.lastIndexOf("/");
  let filename = filePath.substring(startIndex);
  if (filename.indexOf("\\") === 0 || filename.indexOf("/") === 0) {
    filename = filename.substring(1);
  }

  return filename;
};
